import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import SidebarMenu from './components/SidebarMenu';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2875EA',
      contrastText: 'white',
      dark: '#194485',
    },
    mode: 'dark',
  },
  typography: {
    fontFamily: 'CircularStd',
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          '@media (max-width:375px)': {
            '&::before': {
              filter: 'blur(40px)',
            },
          },
          '@media (min-width: 375px)': {
            padding: 'clamp(30px, 5%, 50px)',
          },
          '@media (min-width: 1200px)': {
            maxWidth: '100%',
          },
        },
      },
    },
  },
});

const ProtectedRoute = () => {
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const navigate = useNavigate();

  async function logoutUser() {
    try {
      await Auth.signOut();
      navigate('/login');
    } catch (error) {
      console.error('Error logging out:', error);
      throw error; // or handle the error as per your needs
    }
  }

  function handleLogout() {
    logoutUser();
  }

  async function checkAuth() {
    try {
      const user = await Auth.currentAuthenticatedUser();
    } catch {
      navigate('/login');
    }
  }

  useEffect(() => {
    checkAuth();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <SidebarMenu
        handleLogout={handleLogout}
        toggleDrawer={() => setDrawerOpen(!drawerOpen)}
        drawerOpen={drawerOpen}
      />
      <Outlet />
    </ThemeProvider>
  );
};

export default ProtectedRoute;
